interface SectionTitleProps {
  title: string;
  subtitle?: string;
}

export function SectionTitle({ title, subtitle }: SectionTitleProps) {
  return (
    <div className="flex flex-col gap-1">
      <h1 className="text-2xl font-bold tracking-tight m-0">{title}</h1>
      {subtitle && <p className="text-sm text-black/50 dark:text-white/50 m-0">{subtitle}</p>}
    </div>
  );
}
